module.exports = __webpack_public_path__ + "img/calling.5f3eecfa.svg";